import { SiroccoDataError } from './rtdb';
import { t } from '../i18n';

/**
 * Le spot courant, retenu le temps de la session.
 *
 * Les ecrans appellent `posts.feed()` sans preciser de ville : c'est
 * l'API telle qu'elle a toujours ete, et la changer voudrait dire
 * retoucher les vingt-sept ecrans. Cote serveur, ce contexte etait
 * deduit du compte a chaque requete ; ici on le garde simplement en
 * memoire, pose par la session a la connexion et a chaque changement de
 * spot.
 */
let currentServerId: string | null = null;

export function setCurrentServerId(serverId: string | null): void {
  currentServerId = serverId;
}

export function getCurrentServerId(): string | null {
  return currentServerId;
}

/** Le spot courant, ou une erreur lisible si aucun n'a ete choisi. */
export function requireServerId(): string {
  if (!currentServerId) {
    throw new SiroccoDataError(t.commun.choisisUnSpot, 'no-server');
  }
  return currentServerId;
}
